import { MRRResponseDTO } from '@core/api/dtos/response/accounts/mrr'
import { MRR } from '@core/api/entities/account/mrr'

export class MRRMapper {
	static toEntity(dto: MRRResponseDTO): MRR {
		return MRR.create({
			total: dto.total,
			totalOwn: dto.total_own,
			totalBonus: dto.total_bonus,
			totalPlayers: dto.total_players,
			totalPlayersBonus: dto.total_players_bonus,
			totalBoxes: dto.total_boxes,
			totalBoxesBonus: dto.total_boxes_bonus,
			qPlayers: dto.q_players,
			qPlayersOwn: dto.q_players_own,
			qPlayersBonus: dto.q_players_bonus,
			qBoxes: dto.q_boxes,
			qBoxesOwn: dto.q_boxes_own,
			qBoxesBonus: dto.q_boxes_bonus,
			qLicenses: dto.q_licenses,
			qLicensesOwn: dto.q_licenses_own,
			qLicensesBonus: dto.q_licenses_bonus,
			currency: dto.currency,
			lastMRR: dto.last_mrr,
			segmentation: dto.segmentation,
		})
	}
}
